import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  container: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 32px;
    border: 1px solid ${colors.prussian300};
    border-radius: 10px;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    padding: 16px;
  `,
  illustrationContainer: css`
    position: relative;
    width: 100%;
  `,
  illustration: css`
    display: flex;
    justify-content: center;
    padding-left: 36px;
    height: 316px;
    @media (max-width: 480px) {
      max-height: 190px;
      padding-left: 24px;
    }
  `,
  description: css`
   padding-bottom: 24px;
  `,
  descriptionContainer: css`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px 16px 24px;
    border-top: 1px solid ${colors.prussian300};
    background-color: ${colors.prussian200};
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  `,
};

export default styles;
